import loadLocaleBundle from 'Translations/loadLocaleBundle'
import configureReactRailsContext from 'Utils/configureReactRailsContext'
import mountRootsIncrementally from 'Utils/mountRootsIncrementally'

// Start fetching the active locale's translations at script-eval time so the
// bundle is registered before components hydrate (no English flash on non-EN
// pages). Resolves immediately on English pages.
const localeReady = loadLocaleBundle()

const init = () => {
  localeReady.then(() => {
    const ReactRailsUJS = require("react_ujs")
    // this approach requires all components inside NewHomepage pod.
    // if evaluation time for script becomes too long it can be replaced with
    // a different folder structure and require call for each component separately.
    const context = require.context(
      'Pods',
      true,
      // eslint-disable-next-line max-len
      /\/(NewHomepage|(Shared\/(TrustedBrands|TrendingModelsSection|ValueProposition|PrintModels|SubscriptionPromoSection)))\/(?!.*(?:test|story).*$).*$/
    )

    configureReactRailsContext(ReactRailsUJS, context)

    // The navbar pack hydrates in this same `load` task. Each homepage root then gets
    // its own task (and far-away roots wait for the viewport), so a tap between them is
    // handled instead of queueing behind the whole page's hydration.
    mountRootsIncrementally(ReactRailsUJS, document.getElementById('home-elements'))
  })
}

document.readyState === 'complete' ? init() : window.addEventListener('load', init)
